// Official Fados à Mesa social profiles. null = channel not active yet.
export const SOCIAL = {
    instagram: "https://www.instagram.com/fadosamesa/",
    facebook: "https://www.facebook.com/profile.php?id=61594181040230",
};
